module.exports = __webpack_public_path__ + "static/media/outline-icons.cd6c777f.woff2";